import { SC } from "../helper/ServerCall"
import { pathSegment } from "../helper/queryString";

export const mosaicService = {
    getAllMosaicStyles,
    updateOrderMosaic
}

function getAllMosaicStyles(data) {
    if (data) {
        return SC.getCall('mosaicStyles', { selectable: data.selectable });
    }
    return SC.getCall('mosaicStyles');
}

function updateOrderMosaic(id, data) {
    return SC.putCall(`updateOrderMosaic/${pathSegment(id)}`, data);
}
